import React from 'react'
import EcgComplianceChart from './charts/EcgComplianceChart'
import QuestionnaireComplianceChart from './charts/QuestionnaireComplianceChart'
import WatchWeartimeComplianceChart from './charts/WatchWeartimeComplianceChart'
import type { MetricKey } from '../../../common/types/ResearchDashboardMetricsDTO'

interface Props {
  selectedMetric: MetricKey
}

export default function ResearchDashboardChart ({ selectedMetric }: Props): React.ReactElement {
  return (
    <div className='research-dashboard-charts'>
      {selectedMetric === 'ecg' && <EcgComplianceChart />}
      {selectedMetric === 'questionnaires' && <QuestionnaireComplianceChart />}
      {selectedMetric === 'watchWeartime' && <WatchWeartimeComplianceChart />}
    </div>
  )
}
